import type { TermsTranslations } from '../en-US/terms.translations';

export const termsTranslations: TermsTranslations = {
  title: 'Conditions Générales',
  lastUpdated: 'Dernière mise à jour : 7 mars 2024',
  sections: {
    introduction: {
      title: 'Introduction',
      content:
        'Bienvenue sur BiteCritic. En utilisant notre plateforme, vous acceptez ces conditions générales. Veuillez les lire attentivement.',
    },
    userAgreement: {
      title: 'Accord Utilisateur',
      content:
        'En créant un compte sur BiteCritic, vous acceptez les responsabilités suivantes :',
      items: [
        "Fournir des informations précises et complètes lors de l'inscription.",
        'Maintenir la confidentialité de votre mot de passe.',
        'Être responsable de toutes les activités sur votre compte.',
        'Notifier immédiatement BiteCritic de toute utilisation non autorisée.',
        "Ne pas utiliser le compte d'une autre personne sans autorisation.",
      ],
    },
    content: {
      title: 'Directives de Contenu',
      content:
        'Tout le contenu que vous publiez sur BiteCritic doit respecter ces directives :',
      items: [
        'Les critiques doivent être honnêtes et basées sur des expériences réelles.',
        'Ne pas publier de contenu diffamatoire, obscène ou offensant.',
        "Ne pas publier de contenu qui enfreint les droits d'auteur ou la propriété intellectuelle.",
        'Ne pas utiliser la plateforme pour du spam ou des activités commerciales non autorisées.',
        'Les photos doivent être authentiques et respecter la vie privée des autres.',
      ],
    },
    contentRights: {
      title: 'Droits sur le Contenu et Conservation',
      content: 'Concernant votre contenu sur BiteCritic :',
      items: [
        "Vous conservez la propriété de votre contenu, mais vous nous accordez une licence mondiale, non exclusive et gratuite pour utiliser, afficher, distribuer, reproduire, modifier et créer des œuvres dérivées de votre contenu en lien avec le Service et à des fins promotionnelles et marketing de BiteCritic, y compris, mais sans s'y limiter, l'affichage sur notre site web, notre application et des plateformes tierces telles que les réseaux sociaux",
        'Lorsque vous supprimez votre compte, vos informations personnelles seront anonymisées, mais vos avis et autres contenus peuvent être conservés',
        'Le contenu apparaîtra comme publié par un "Utilisateur Anonyme" après la suppression du compte',
        'Pour une suppression complète de tout votre contenu, vous devez nous contacter directement à hurricanesoftwaresolutions@gmail.com',
        'Nous pouvons continuer à afficher des avis anonymisés pour préserver la valeur de la plateforme pour tous les utilisateurs',
      ],
    },
    privacy: {
      title: 'Confidentialité',
      content:
        'Nous respectons votre vie privée et nous nous engageons à protéger vos données personnelles :',
      items: [
        'Nous collectons uniquement les informations nécessaires au fonctionnement de la plateforme.',
        'Vos données personnelles ne seront pas vendues à des tiers.',
        'Vous pouvez demander une copie de vos données ou leur suppression.',
        'Nous utilisons des cookies pour améliorer votre expérience sur la plateforme.',
        "Pour plus d'informations, consultez notre Politique de Confidentialité complète.",
      ],
    },
    community: {
      title: 'Directives Communautaires',
      content:
        'Pour maintenir une communauté respectueuse, veuillez suivre ces directives :',
      items: [
        'Traiter tous les membres avec respect et courtoisie.',
        'Ne pas harceler, intimider ou discriminer les autres utilisateurs.',
        'Respecter les opinions divergentes et engager des discussions constructives.',
        'Signaler tout contenu inapproprié ou comportement abusif.',
        "Ne pas créer plusieurs comptes ou usurper l'identité d'autres personnes.",
      ],
    },
    termination: {
      title: 'Résiliation de Compte',
      content:
        'BiteCritic se réserve le droit de suspendre ou de résilier votre compte dans les circonstances suivantes :',
      items: [
        'Violation de ces conditions générales.',
        "Comportement abusif envers d'autres utilisateurs.",
        'Publication de contenu inapproprié ou illégal.',
        'Utilisation de la plateforme pour des activités frauduleuses.',
        'Inactivité prolongée du compte.',
        'Anonymiser les données utilisateur mais conserver le contenu lors de la suppression du compte',
        'Traiter les demandes de suppression complète par e-mail dans un délai de 30 jours',
      ],
    },
  },
  agreement: {
    checkbox:
      "J'ai lu et j'accepte les Conditions Générales et la Politique de Confidentialité de BiteCritic.",
    required: 'Vous devez accepter les conditions générales pour continuer.',
    view: 'Voir les conditions générales complètes',
  },
};

export default termsTranslations;
